import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.css';

export type SpinnerTypes = 'blue' | 'white' | 'gray';
export type SpinnerVariantTypes = 'small' | 'medium' | 'large';

type SpinnerProps = {
  className?: string;
  type: SpinnerTypes;
  variant: SpinnerVariantTypes;
  id?: string;
};

export const Spinner: FC<SpinnerProps> = ({
  type,
  variant = 'small',
  id = 'spinner',
  className,
}) => {
  const spinnerClass = classNames(
    styles.spinner,
    styles[type],
    styles[variant],
    className
  );

  return <div className={spinnerClass} data-testid={id} />;
};
